import { Link } from 'react-router-dom'

import monitoring from '@/assets/images/services/monitoring.webp'
import { Button } from '@/components/button'
import { CertificateIcon } from '@/components/icons/services/carbon/certificate'
import { DefaultsEsgIcon } from '@/components/icons/services/defaults-esg'
import { LaptopIcon } from '@/components/icons/services/monitoring/laptop'
import { SatelliteBlockchainIcon } from '@/components/icons/services/monitoring/satellite-blockchain'

import * as Card from '../../components/services-sections/card'
import * as Section from '../../components/services-sections/root'

export function MonitoringSection() {
  return (
    <section className="flex flex-col">
      <Section.ContainerRoot>
        <Section.Image src={monitoring} />
        <Section.Container>
          <Section.Title>Monitoração</Section.Title>
          <Section.Description>
            <Section.DescriptionBold>
              Inteligência orbital para gestão estratégica de ativos naturais.
            </Section.DescriptionBold>{' '}
            Monitoramento satelital, algoritmos exclusivos e blockchain para
            gestão precisa de ativos naturais. Compliance, proteção e
            valorização — tudo em tempo quase real.
          </Section.Description>
        </Section.Container>
      </Section.ContainerRoot>

      <div className="flex flex-col gap-24">
        <Card.Scroll>
          {/* Card 1 */}
          <Card.Root>
            <Card.Container icon={SatelliteBlockchainIcon}>
              <Card.Description>
                <Card.DescriptionBold>
                  Satélites + IA + Blockchain:
                </Card.DescriptionBold>{' '}
                visibilidade total das suas áreas
              </Card.Description>
            </Card.Container>
          </Card.Root>

          {/* Card 2 */}
          <Card.Root>
            <Card.Container icon={DefaultsEsgIcon}>
              <Card.Description>
                ESG com precisão e{' '}
                <Card.DescriptionBold>dados auditáveis</Card.DescriptionBold> em
                tempo quase real
              </Card.Description>
            </Card.Container>
          </Card.Root>

          {/* Card 3 */}
          <Card.Root>
            <Card.Container icon={CertificateIcon}>
              <Card.Description>
                Alertas de risco,{' '}
                <Card.DescriptionBold>
                  validação de carbono
                </Card.DescriptionBold>{' '}
                e certificação de boas práticas
              </Card.Description>
            </Card.Container>
          </Card.Root>

          {/* Card 4 */}
          <Card.Root>
            <Card.Container icon={LaptopIcon}>
              <Card.Description>
                <Card.DescriptionBold>
                  Plataforma interativa
                </Card.DescriptionBold>{' '}
                com integração ao mercado de carbono
              </Card.Description>
            </Card.Container>
          </Card.Root>
        </Card.Scroll>
        <Button asChild className="mx-auto max-w-96 uppercase md:w-full">
          <Link to="/monitoring">Saiba mais</Link>
        </Button>
      </div>
    </section>
  )
}
